import { postApi } from './index';

/** FCM device-token registry (#78). Register upserts; unregister deletes by token value. */
const DEVICE_TOKENS_BASE = 'system/device-tokens/';

export function registerDeviceToken(data) {
	return postApi(DEVICE_TOKENS_BASE, data);
}

export function unregisterDeviceToken(data) {
	return postApi(`${DEVICE_TOKENS_BASE}unregister/`, data);
}
